import api from './api';

const geocodingService = {
  async search(query) {
    const { data } = await api.get('/geocoding/search', { params: { q: query } });
    return data;
  },

  async reverse(latitude, longitude) {
    const { data } = await api.get('/geocoding/reverse', {
      params: { latitude, longitude },
    });
    return data;
  },
};

export default geocodingService;
